import type { ISEOProps } from "../types/core";

export const ContentProviderAgreementPageSEO: ISEOProps = {
  title: "Content Provider Agreement - Sugar Cribs",
  description:
    "Read Sugar Cribs Content Provider Agreement for creators. Understand the terms and conditions for content creators.",
};
